import React from 'react';
import { NumberInput } from '@chakra-ui/react';
import { NumberInputField } from '@chakra-ui/react';

interface CheckInfoNumber {
  ViewInt: number;
  ViewDigit: number;
  Value: string;
}

interface props {
  CheckInfo: CheckInfoNumber;
  inputValue: string | undefined;
  setValue: React.Dispatch<React.SetStateAction<string | undefined>>;
}
const GetDotCount = (inputData: string) => {
  const count = inputData.match(/\./g);
  if (count !== null && count !== undefined) {
    return count.length;
  }
  return 0;
};

export const CustomNumberInput: React.FC<props> = (props) => {
  const { CheckInfo, inputValue, setValue } = props;

  const NumberInputCheck = (inputData: string) => {
    // ChakraUiのNumberInputは-とeが入力できるため、はじく
    if (inputData.slice(-1) === 'e' || inputData.slice(-1) === '-') {
      inputData = inputData.replace(inputData.slice(-1), '');
      return setValue(inputData);
    }
    if (
      inputData.length <= CheckInfo.ViewInt &&
      GetDotCount(inputData) < 1 &&
      inputValue?.charAt(0) !== '0'
    ) {
      setValue(inputData);
      return;
    } else {
      if (inputData.length === 0) {
        setValue(inputData);
        return;
      }
      if (GetDotCount(inputData) < 2 && inputData.charAt(0) !== '.') {
        if (
          inputData.length === CheckInfo.ViewInt + 1 &&
          CheckInfo.ViewDigit > 0 &&
          inputData.charAt(3) === '.'
        ) {
          setValue(inputData);
          return;
        } else if (
          CheckInfo.ViewDigit !== 0 &&
          inputData.substring(inputData.indexOf('.') + 1).length <=
            CheckInfo.ViewDigit
        ) {
          setValue(inputData);
          return;
        }
      }
    }
  };

  return (
    <>
      <NumberInput
        mt={2}
        w='95%'
        value={inputValue}
        onChange={(e) => NumberInputCheck(e)}
      >
        <NumberInputField placeholder={CheckInfo.Value} />
      </NumberInput>
    </>
  );
};
